import { useMemo } from "react";
import WindowedSelect from "react-windowed-select";
import { components } from "react-select";

export default function BrandFilter({
  brandList = [],
  setPage,
  setBrandFilter,
  filterBrand,
}) {
  const options = useMemo(() => {
    return [
      { label: "Select Brand", value: "PLACEHOLDER", isDisabled: true },
      { label: "All", value: "ALL" },
      ...brandList.map((brand) => ({
        label: brand.brand_name,
        value: brand.brand_id,
      })),
    ];
  }, [brandList]);

  const selectedOption = useMemo(() => {
    return (
      options.find(
        (opt) => opt.value === filterBrand || opt.value === Number(filterBrand)
      ) || null
    );
  }, [options, filterBrand]);

  const styles = {
    control: (base) => ({
      ...base,
      width: "fit-content",
      minHeight: 50,
      height: 50,
      padding: "0 18px",
      borderRadius: 15,
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      border: "none",
      backgroundColor: "#fff",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0,
      display: "flex",
      alignItems: "center",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: 14,
      color: "#000",
      opacity: 0.4,
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: 14,
      color: "#000",
      opacity: 0.4,
    }),
    option: (base, { isFocused, isSelected, isDisabled }) => ({
      ...base,
      padding: "8px 12px",
      backgroundColor: isFocused ? "#f5f5f5" : "#fff",
      fontWeight: isSelected ? 600 : 400,
      color: isDisabled ? "#9e9e9e" : "#212121",
      cursor: isDisabled ? "not-allowed" : "pointer",
      opacity: isDisabled ? 0.6 : 1,
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 10,
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
      zIndex: 20,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "rgba(128, 128, 128, 0.7)",
      paddingRight: 8,
    }),
    indicatorSeparator: () => null,
  };

  const handleTypeSelect = (option) => {
    if (!option) return;

    setBrandFilter(option.value);
    setPage((prev) => ({ ...prev, page: 1 }));
  };

  return (
    <WindowedSelect
      options={options}
      value={selectedOption}
      onChange={handleTypeSelect}
      styles={styles}
      isSearchable
      placeholder="Brands"
      filterOption={(option, input) =>
        option.value === "ALL" ||
        option.label.toLowerCase().includes(input.toLowerCase())
      }
      components={{
        IndicatorSeparator: () => null,
        ValueContainer: (props) => (
          <components.ValueContainer {...props}>
            {props.hasValue && (
              <span
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#000000",
                  mixBlendMode: "normal",
                  opacity: 0.4,
                }}
              >
                Status: &nbsp;
              </span>
            )}
            {props.children}
          </components.ValueContainer>
        ),
      }}
    />
  );
}
